// extracted by mini-css-extract-plugin
module.exports = {"reset-password-form":"ChangePassword_reset-password-form__3PqBK","form-group":"ChangePassword_form-group__2I6LK","error":"ChangePassword_error__-2fc9"};